// extracted by mini-css-extract-plugin
export var acitonButtons = "_fc-0";
export var additionalIcon = "_fc-f";
export var block = "_fc-1";
export var blockContent = "_fc-7";
export var blockDescription = "_fc-8";
export var blockIcon = "_fc-9";
export var blockTitle = "_fc-6";
export var border = "_fc-a";
export var center = "_fc-l";
export var edge = "_fc-b";
export var edgeLabel = "_fc-c";
export var edgePath = "_fc-d";
export var error = "_fc-e";
export var flowchart = "_fc-g";
export var flowchartContent = "_fc-h";
export var highlighted = "_fc-3";
export var hover = "_fc-4";
export var icon = "_fc-i";
export var left = "_fc-m";
export var navButton = "_fc-j";
export var navButtons = "_fc-k";
export var right = "_fc-n";
export var selected = "_fc-2";
export var small = "_fc-5";